import { createAction } from '@reduxjs/toolkit';

export const ADD_MESSAGE_ACTION_TYPE = 'saga/addMessage';
export const addMessageAction = createAction(ADD_MESSAGE_ACTION_TYPE);
